export default {
  selected: 'Ausgewählt',
  deselect_all_selected_options: 'Alle ausgewählten Optionen abwählen',
  expanded: 'Erweitert',
  collect: 'Sammeln',
  no_options_available: 'Keine Optionen verfügbar',
  required: 'Erforderlich',
  input_clear_aria_label: 'Eingabe löschen',
  input_show_hide_password_aria_label: 'Passwort anzeigen oder ausblenden',
  input_increment_aria_label: 'Wert erhöhen',
  input_decrement_aria_label: 'Wert verringern',
  english: 'Englisch',
  chinese: 'Chinesisch',
  portuguese: 'Portugiesisch',
  spanish: 'Spanisch',
  dutch: 'Niederländisch',
  french: 'Französisch',
  german: 'Deutsch',
  russian: 'Russisch',
  ukrainian: 'Ukrainisch',
  korean: 'Koreanisch',
  italian: 'Italienisch',
  czech: 'Tschechisch',
  access_your_account: 'Zugriff auf Ihr Konto',
  use_your_company_credentials_to_get_started:
    'Verwenden Sie Ihre Unternehmensanmeldeinformationen, um zu beginnen',
  internal_user_login: 'Interner Benutzer (SSO)',
  external_user_login: 'Externer Benutzer',
  or: 'oder',
  keycloak_init_error:
    'Verbindung zum Authentifizierungsserver nicht möglich. Bitte überprüfen Sie Ihre Netzwerkverbindung und versuchen Sie es erneut.',
  this_link_has_expired: 'Dieser Link ist abgelaufen',
  login: 'Anmelden',
  sample_no_production_date_message: 'Herstellungsdatum muss ausgewählt werden',
  free_comment: 'Freier Kommentar',
  save_comments: 'Speichern & Schließen',
  round_list_rounds: 'Runden',
  round_edit_round: 'Runde bearbeiten',
  round_new_round: 'Neue Runde',
  round_remove_round: 'Möchten Sie die Runde wirklich löschen',
  round_schedule: 'Zeitlicher Ablauf',
  round_tasters_unselect_all: 'Alle Verkoster abwählen',
  round_tasters_select_all: 'Alle Verkoster auswählen',
  round_close: 'Runde schließen',
  round_close_message: 'Sind Sie sicher, dass Sie die Runde beenden wollen',
  round_create_site_message:
    'Sie erstellen eine Runde, die nicht aus Ihrer Brauerei stammt!',
  round_closed_message: 'Geschlossene Runden können nicht bearbeitet werden',
  round_status_created: 'Erstellt',
  round_status_samples: 'Proben',
  round_status_scheduled: 'Geplant',
  round_status_tasters: 'Verkoster',
  round_status_in_progress: 'Im Gange',
  round_status_finished: 'Fertig',
  round_status_closed: 'Abgeschlossen',
  round_schedule_start_finish_date:
    'Das Startdatum kann nicht größer als das Enddatum sein!',
  round_schedule_finish_date_no_start_date:
    'Sie müssen zuerst ein Startdatum auswählen!',
  round_disabled_discussion_tooltip:
    'Sie können nicht zu einer Diskussion einer unvollendeten Runde gehen',
  round_up_down_maintenance_tooltip:
    'Diese Funktion befindet sich in Wartung und ist vorübergehend nicht verfügbar',
  round_delete_other_users_rounds:
    'Du bist nicht berechtigt, eine Runde zu löschen, die nicht von dir erstellt wurde',
  round_randomize_samples_order_button: 'Mischen',
  round_block_results_tooltip:
    'Sperren Sie das Herunterladen der Ergebnisse dieser Runde im Berichtsbildschirm. Wenn die Schaltfläche deaktiviert ist',
  round_block_results_confirm:
    'Sind Sie sicher, dass Sie die Ergebnisse der Runde sperren/entsperren möchten?',
  round_block_results_no_privilege:
    'Sie haben nicht die Berechtigung, die Ergebnisse von Runden von diesem Ort aus zu sperren/entsperren.',
  sample_list_samples: 'Proben',
  sample_edit_sample: 'Probe bearbeiten',
  sample_new_sample: 'Neue Probe',
  sample_remove_sample: 'Probe entfernen',
  sample_upload_document: 'Dokumente hochladen',
  sample_download_documents: 'Dokumente herunterladen',
  sample_tasted_dates: 'Geschmacksdatum',
  sample_upload_message: 'Mehrere Dokumente hochladen',
  sample_not_for_kpi: 'Nicht für KPI',
  sample_package: 'Paket',
  sample_volume: 'Volumen',
  sample_production_date: 'Produktionsdatum',
  sample_expire_date: 'Haltbarkeitsdatum',
  sample_trial_identifier: 'Testkennung',
  sample_project_name: 'Projektname',
  sample_linked: 'Verbunden mit einer Runde',
  sample_expire_bigger_than_production:
    'Das Produktionsdatum kann nicht größer als das Ablaufdatum sein!',
  sample_no_site_message: 'Es ist obligatorisch, eine Zone auszuwählen',
  sample_no_brand_message: 'Es ist obligatorisch, eine Marke auszuwählen.',
  sample_duplicated_kpi_message: 'Es gibt bereits einen KPI für den Monat',
  sample_duplicated_kpi_message_quarter:
    'Es gibt bereits einen KPI für das von Ihnen ausgewählte Quartal, die Marke und die Website, und Sie können nicht speichern.',
  sample_duplicated_project_message:
    'Es gibt bereits ein Muster mit diesem Projektnamen und dieser Testkennung für diese Brauerei und Marke',
  sample_project_no_name_or_trial:
    'Projektname und Testkennung sind obligatorisch, wenn Sie ein Muster des Projekttyps erstellen',
  sample_production_to_project_confirm_message:
    'Sie ändern den Typ dieses Beispiels von PRODUKTION in PROJEKT. Möchten Sie fortfahren?',
  sample_project_to_production_confirm_message:
    'Sie ändern den Typ dieses Beispiels von PROJEKT zu PRODUKTION. Möchten Sie fortfahren?',
  sample_no_volume_message:
    'Paket und Volumen sind beim Erstellen/Bearbeiten eines Samples obligatorisch.',
  sample_id_code_message: 'Bitte die vollständige Chargennummer angeben',
  sample_show_all_samples_hint:
    'Anzeigen von Mustern, die bis zu sechs Monate ab heute erstellt wurden. Aktivieren Sie dieses Kontrollkästchen, wenn Sie auch ältere Beispiele sehen möchten',
  sample_show_all_samples_label: 'Alle Beispiele anzeigen',
  package_duplicate: 'Es gibt bereits ein Paket mit diesem Namen',
  common_production: 'Produktion',
  day: 'Tag',
  common_project: 'Projekt',
  group_list_groups: 'Gruppen',
  group_edit_group: 'Gruppe bearbeiten',
  group_new_group: 'Neue Gruppe',
  group_remove_group: 'Gruppe entfernen',
  group_close_modal: 'Schließen',
  group_duplicated_user:
    'Dieser Benutzer wurde bereits zu dieser Gruppe hinzugefügt!',
  group_no_name_message: 'Es ist notwendig, einen Gruppennamen einzugeben',
  group_no_zone_message: 'Es ist notwendig, eine Zone auszuwählen',
  group_no_users_message:
    'Es ist notwendig, mindestens einen Verkoster auszuwählen',
  family_list_families: 'Stile',
  family_edit_family: 'Stil bearbeiten',
  family_new_family: 'Neuer Stil',
  family_remove_family: 'Stil entfernen',
  families_page_description:
    'Verwalten Sie alle Stile und deren Konfigurationen an einem Ort',
  family_new_page_description:
    'Füllen Sie die Stilinformationen aus und schließen Sie die Erstellung ab.',
  family_edit_page_description: 'Stilinformationen bearbeiten.',
  family_save_success: 'Stil erfolgreich erstellt!',
  family_update_success: 'Stil erfolgreich aktualisiert!',
  family_save_failed: 'Stil konnte nicht gespeichert werden.',
  family_save_success_desc: 'Überprüfen Sie es unten in den Stilen.',
  family_update_success_desc: 'Überprüfen Sie es unten in den Stilen.',
  family_save_failed_desc: 'Bitte versuchen Sie es in einem Moment erneut.',
  the_name_is_duplicated: 'Der Name ist bereits vergeben.',
  common_style_name: 'Stilname',
  common_warning: 'Warnung',
  cancel_new_family_title: 'Neuen Stil abbrechen?',
  cancel_edit_family_title: 'Stilbearbeitung abbrechen?',
  cancel_new_family_confirm: 'Neuen Stil abbrechen',
  cancel_edit_family_confirm: 'Stilbearbeitung abbrechen',
  family_remove_success: 'Stil erfolgreich entfernt',
  family_remove_failed: 'Stil konnte nicht entfernt werden',
  family_delete_title: 'Stil löschen?',
  family_delete_description:
    'Der Stil {{name}} wird dauerhaft entfernt. Möchten Sie wirklich fortfahren?',
  family_delete_success: 'Stil erfolgreich gelöscht!',
  family_delete_success_desc: 'Der Stil wurde entfernt.',
  family_delete_failed: 'Stil konnte nicht gelöscht werden.',
  family_delete_failed_desc: 'Bitte versuchen Sie es in einem Moment erneut.',
  family_has_no_english_name:
    'Achtung: Der Style-Name muss auf Englisch angegeben werden',
  brand_list_brands: 'Marken',
  brand_edit_brand: 'Marke bearbeiten',
  brand_new_brand: 'Neue Marke',
  brand_remove_brand: 'Marke entfernen',
  brand_profile_picture: 'Bierprofilbild hochladen',
  brand_upload_brand_logo: 'Markenlogo hochladen',
  brand_duplicate: 'Achtung: Es gibt ein Bier mit diesem Namen',
  brand_has_no_english_name:
    'Sie müssen einen Markennamen und ein entsprechendes Bierprofil ausfüllen',
  brand_upload_help_message: 'Nur PNG- und JPG-Dateien',
  brand_has_no_product_type: 'Sie müssen einen Produkttyp auswählen',
  package_list_packages: 'Pakete',
  package_edit_package: 'Pakete bearbeiten',
  package_new_package: 'Neues Paket',
  package_remove_package: 'Paket entfernen',
  packages_page_description:
    'Verwalten Sie alle Pakettypen und ihre Konfigurationen an einem Ort.',
  comments_page_description:
    'Verwalten Sie alle Attribute und ihre Konfigurationen an einem Ort.',
  comments_new_page_description:
    'Füllen Sie die Attributinformationen aus und schließen Sie die Erstellung ab.',
  comments_edit_page_description:
    'Attributinformationen bearbeiten und die Aktualisierung abschließen.',
  comment_attribute_name: 'Name des Geschmacksattributs',
  comment_select_category: 'Wählen Sie die Geschmackskategorie',
  packages_edit_page_description:
    'Paketinformationen bearbeiten und die Aktualisierung abschließen.',
  package_successfully_created: 'Paket erfolgreich erstellt!',
  package_successfully_created_desc:
    'Überprüfen Sie es in den untenstehenden Paketen.',
  package_successfully_updated: 'Paket erfolgreich aktualisiert!',
  package_successfully_updated_desc:
    'Überprüfen Sie es in den untenstehenden Paketen.',
  packages_new_page_description:
    'Füllen Sie die Paketinformationen aus und schließen Sie die Erstellung ab.',
  package_name: 'Paketname',
  content_already_exists: 'Inhalt bereits vorhanden.',
  language_english: 'Englisch',
  language_chinese: 'Chinesisch',
  language_portuguese: 'Portugiesisch',
  language_spanish: 'Spanisch',
  language_dutch: 'Niederländisch',
  language_french: 'Französisch',
  language_german: 'Deutsch',
  language_russian: 'Russisch',
  language_ukrainian: 'Ukrainisch',
  language_korean: 'Koreanisch',
  language_italian: 'Italienisch',
  package_has_no_english_name:
    'Achtung: Der Paketname muss auf Englisch angegeben werden',
  package_volumes: 'Volumen',
  package_new_volume: 'Neues Volumen',
  package_remove_volume: 'Volumen entfernen',
  degree_list_degrees: 'Intensitäten',
  degree_edit_degree: 'Intensität bearbeiten',
  degree_new_degree: 'Neue Intensität',
  degree_remove_degree: 'Intensität entfernen',
  category_list_categories: 'Kategorien',
  category_edit_category: 'Geschmackskategorie bearbeiten',
  category_new_category: 'Neue Geschmackskategorie',
  category_remove_category: 'Geschmackskategorie entfernen',
  comment_list_comments: 'Attribute',
  comment_edit_comment: 'Geschmacksattribut bearbeiten',
  comment_new_comment: 'Neues Geschmacksattribut',
  comment_remove_comment: 'Geschmacksattribut entfernen',
  comment_cancel_new_title: 'Neues Geschmacksattribut verwerfen?',
  comment_cancel_edit_title: 'Bearbeiten des Geschmacksattributs verwerfen?',
  comment_cancel_new_confirm: 'Neues Geschmacksattribut verwerfen',
  comment_cancel_edit_confirm: 'Bearbeiten des Geschmacksattributs verwerfen',
  comment_successfully_created: 'Geschmacksattribut erfolgreich erstellt!',
  comment_successfully_created_desc: 'Prüfe es unten im Attribut.',
  comment_successfully_updated: 'Geschmacksattribut erfolgreich aktualisiert!',
  comment_successfully_updated_desc: 'Prüfe es unten im Attribut.',
  comment_create_failed: 'Geschmacksattribut konnte nicht erstellt werden.',
  comment_update_failed: 'Geschmacksattribut konnte nicht aktualisiert werden.',
  comment_failed_desc: 'Bitte versuche es gleich erneut.',
  comment_delete_title: 'Attribut löschen?',
  comment_delete_description:
    'Das Attribut {{name}} wird dauerhaft entfernt. Möchtest du wirklich fortfahren?',
  comment_delete_success: 'Attribut erfolgreich gelöscht!',
  comment_delete_success_desc: 'Prüfe es unten im Attribut.',
  comment_delete_failed: 'Attribut konnte nicht gelöscht werden.',
  comment_delete_failed_desc: 'Bitte versuche es gleich erneut.',
  user_list_users: 'Benutzer',
  user_edit_user: 'Benutzer bearbeiten',
  user_new_user: 'Neuer ABI-Vertragspartner',
  user_export_users: 'Benutzer exportieren',
  user_list_profiles: 'Profile',
  user_profile_name: 'Profilname',
  user_profile_select: 'Wählen Sie ein Profil',
  user_profile_remove: 'Profil entfernen',
  user_profile_save: 'Profil sichern',
  user_remove_user: 'Benutzer entfernen',
  user_use_terms: 'Akzeptierte Nutzungsbedingungen',
  report_list_report: 'Berichte',
  report_start_date: 'Starttermin',
  report_end_date: 'Endtermin',
  common_privileges: 'Privilegien',
  common_abi_name: 'ABI-Name',
  common_id: 'ID',
  common_ranked: 'Rang',
  common_week: 'Woche',
  common_weeks: 'Wochen',
  common_days: 'Tage',
  common_category: 'Geschmackskategorie',
  common_category_sample: 'Kategorie',
  common_degree: 'Intensität',
  common_comment: 'Geschmacksattribut',
  common_status: 'Status',
  common_zone: 'Zone',
  common_country: 'Land',
  common_site: 'Brauerei',
  common_start_date: 'Startdatum',
  common_finish_date: 'Enddatum',
  common_round_type: 'Testtyp',
  common_type: 'Typ',
  common_round: 'Runden',
  common_round_id: 'Runde ID',
  common_tasters: 'Verkoster',
  common_sample_performance: 'Beispielleistung',
  common_taste: 'Geschmack',
  common_key_taster: 'Key-Schnupper',
  common_sample: 'Stichprobe',
  common_samples: 'Proben',
  common_sample_type: 'Beispielstyp',
  common_family: 'Stil',
  common_brand: 'Marke',
  common_product_type: 'Produktart',
  common_temperature: 'Lagerzustand',
  common_storage_times: 'Lagerzeit',
  common_sku: 'Artikelnummer',
  common_batch: 'Identifikationsnummer',
  common_kpi_month: 'KPI-Monat',
  common_logo: 'Logo',
  common_name: 'Name',
  common_notes: 'Anmerkungen',
  common_email: 'Email',
  common_language: 'Sprache',
  common_terms_of_use: 'Nutzungsbedingungen',
  common_new: 'Neu',
  common_profile: 'Profil',
  common_filter: 'Benutzer filtern',
  common_download: 'Herunterladen',
  download: 'Herunterladen',
  common_save: 'Speichern',
  common_cancel: 'Abbrechen',
  cancel_add_taster_title: 'Taster hinzufügen abbrechen?',
  cancel_add_taster_description:
    'Sie haben bereits Taster ausgewählt. Beim Abbrechen wird Ihre Auswahl verworfen. Möchten Sie fortfahren?',
  cancel_add_taster_confirm: 'Taster hinzufügen abbrechen',
  cancel_enter_concentration_title: 'Eingabe der Konzentration abbrechen?',
  cancel_enter_concentration_description:
    'Sie haben einen Konzentrationswert eingegeben. Beim Abbrechen wird die nicht gespeicherte Eingabe verworfen. Möchten Sie fortfahren?',
  cancel_enter_concentration_confirm: 'Eingabe der Konzentration abbrechen',
  cancel_new_package_title: 'Neues Paket abbrechen?',
  cancel_edit_package_title: 'Paketbearbeitung abbrechen?',
  cancel_new_package_confirm: 'Neues Paket abbrechen',
  cancel_edit_package_confirm: 'Paketbearbeitung abbrechen',
  common_search_users: 'Benutzer suchen',
  common_search_group: 'Gruppe suchen',
  common_search_taster: 'Schnuppersuche',
  common_no_data: 'Keine Daten anzuzeigen',
  common_edit: 'Bearbeiten',
  common_loading: 'Wird geladen...',
  common_search: 'Suchen...',
  type_more_characters: 'Geben Sie noch {{count}} Zeichen ein...',
  common_cannot_be_empty: '{{field}} darf nicht leer sein',
  common_select_option: 'Wähle eine Option...',
  search_placeholder: 'Suchen...',
  no_search_results: 'Keine Ergebnisse gefunden',
  clear_selection: 'Auswahl löschen',
  common_per_page: 'Zeilen pro Seite',
  common_attributes: 'Attribute',
  common_not_started: 'Nicht angefangen',
  common_in_progress: 'Im Gange',
  common_finished: 'Fertig',
  common_start: 'Start',
  common_detail: 'Detail anzeigen',
  common_delete: 'Löschen',
  common_position: 'Position',
  common_average_key_score: 'Durchschnittliche Schlüsselpunktzahl',
  common_score: 'Punktzahl',
  common_score_scale: 'Bewertungsskala',
  common_intensity: 'Intensität',
  common_report_not_have_data: 'Die ausgewählten Runden hatten keine Stimmen',
  month_0: 'Januar',
  month_1: 'Februar',
  month_2: 'März',
  month_3: 'April',
  month_4: 'Mai',
  month_5: 'Juni',
  month_6: 'Juli',
  month_7: 'August',
  month_8: 'September',
  month_9: 'Oktober',
  month_10: 'November',
  month_11: 'Dezember',
  dropdown_change_picture: 'Bild ändern',
  dropdown_language: 'Sprache',
  dropdown_logout: 'Ausloggen',
  logout_title: 'Abmelden, bitte warten…',
  logout_description: 'Sie werden von Ihrem Konto abgemeldet.',
  round_not_started: 'Nicht angefangen',
  round_in_progress: 'Im Gange',
  round_finished: 'Fertig',
  round_filter_start: 'Start',
  round_round_type_in_profile: 'Im Profil',
  tasting_list_rounds: 'Runden auflisten',
  menu_tasting_session: 'Verkostungssitzung',
  menu_panel_management: 'Panel-Verwaltung',
  menu_process_management: 'Prozessmanagement',
  menu_product_management: 'Produkt Management',
  menu_attributes_management: 'Attributverwaltung',
  tasting_finish_sample: 'Probe fertigstellen',
  tasting_comments: 'Kommentare',
  tasting_beer_profile: 'Bierprofil',
  tasting_need_select_score_comments:
    'Sie müssen eine Punktzahl festlegen und mindestens einen Kommentar hinzufügen, um fortzufahren...',
  tasting_finish_taste: 'Fertig Geschmack',
  tasting_finish_tasting: 'Fertig Geschmack',
  common_no_comments: 'Keine Kommentare',
  previous_comments: 'Vorherige Kommentare',
  review_submit_title:
    'Sind Sie sicher, dass Sie bereit sind, Ihre Ergebnisse zu übermitteln?',
  review_submit_description: 'Sie können später nicht mehr bearbeiten',
  review_finish_taste: 'Fertig Geschmack',
  review_warning_sample_title: 'Sie haben ungeschmeckte Proben!',
  review_warning_sample_description:
    'Möchten Sie fortfahren, ohne sie zu probieren?',
  review_warning_sample_review: 'Rezension',
  review_warning_sample_ok: 'Weitermachen',
  review_warning_tie_sample_title: 'Sie haben Krawattenmuster!',
  review_warning_tie_sample_description:
    'Sie können nicht fortfahren, ohne sie zu bewerten!',
  review_warning_tie_sample_review: 'Rezension',
  common_submit: 'Einreichen',
  common_discussion: 'Diskussion',
  common_not_informed: 'Nicht informiert',
  discussion_order_number: 'Nach Position sortieren',
  discussion_order_brewery: 'Bestellung nach Brauerei',
  discussion_order_ranking: 'Nach Rangfolge sortieren',
  discussion_order_brand: 'Nach Marke bestellen',
  discussion_order_score: 'Nach Punktzahl sortieren',
  discussion_order_key_score: 'Sortieren nach Schlüsselpunktzahl',
  discussion_order_overall_rank: 'Nach Gesamtranglistenergebnis sortieren',
  discussion_order_key_rank: 'Sortieren nach Schlüsselrang',
  discussion_key_ranking: 'Schlüssel-Ranking',
  discussion_export_error: 'Die Datei konnte nicht gespeichert werden!',
  discussion_ranking: 'Rangfolge',
  discussion_overall_ranking: 'Gesamtrangliste',
  common_brewery: 'Brauerei',
  common_trial_identifier: 'ID-Testversion',
  common_key_score: 'Schlüsselpunktzahl',
  round_report: 'Nach Excel exportieren',
  common_comments: 'Kommentare',
  message_you_cannot_delete_all_comments:
    'Du kannst nicht alle Kommentare löschen, wenn du eine Abstimmung bearbeitest',
  common_message_empty_profile: 'Profilname nicht erlaubt leer oder leer',
  common_message_out_score_range: 'außerhalb des Bereichs Score',
  tasting_need_select_score: 'Sie müssen zuerst eine Punktzahl setzen!',
  common_category_name: 'Kategorie',
  categories_new_category: 'Neue Kategorie',
  categories_remove_category: 'Möchten Sie die Kategorie wirklich entfernen?',
  categories_list_categories: 'Kategorien',
  categories_list_all_categories: 'Alle Kategorien',
  common_category_sample_name: 'Stichprobe',
  categories_new_category_sample: 'Neues Muster',
  categories_remove_category_sample:
    'Möchten Sie die Probe wirklich entfernen?',
  categories_list_categories_samples: 'Proben',
  tasting_help: 'Verkostungshilfe',
  common_back: 'Zurück',
  common_next: 'Nächste',
  common_sample_id: 'Proben-ID',
  common_sample_date: 'Beispieldatum',
  common_duplicate: 'Duplikat',
  tasting_raw_materials: 'Rohes Material',
  tasting_example_sensory_risk:
    'Beispiel für das sensorische Hauptrisiko: Nichtübereinstimmung mit dem erwarteten Geschmack',
  tasting_procedure: 'Verfahren',
  tasting_sample_preparation: 'Probenvorbereitung',
  tasting_help_comments: 'Kommentare',
  common_collection_point: 'Sammelpunkt',
  common_collection_date: 'Abholtermin',
  common_brew_number: 'Brühzahlen/MES Anzahl',
  common_need_explain_nok: 'Sie können keine Proben NOK ohne Kommentar haben!',
  common_percent_ok: 'Prozentsatz OK',
  common_show_all: 'Zeige alles',
  common_import: 'Importieren',
  common_download_template: 'Vorlage herunterladen',
  sample_import_message: 'xlsx',
  common_template: 'Vorlage',
  common_yes: 'Jawohl',
  common_no: 'Nein',
  common_only_kpi_sample: 'Nur KPI-Probe',
  common_need_volte_first:
    'Sie können keine Proben ohne vorherige Abstimmung kommentieren!',
  common_name_template: 'Vorlagenname',
  interaction_log: 'Interaktionsprotokoll',
  common_message_zone_empty: 'Zone nicht erlaubt leer oder leer',
  common_message_country_empty: 'Land nicht zulässig leer oder leer',
  common_message_site_empty: 'Brauerei nicht erlaubt, leer oder blanco',
  user_new_profile_save: 'Neues Profil erstellt',
  common_in_privileges: 'in Privilegien',
  common_download_files: 'Dateien herunterladen',
  common_view_details: 'Details anzeigen',
  common_create_action: 'Aktion erstellen',
  common_action_list: 'Aktionsliste',
  common_create_action_description:
    'Füllen Sie die Aktionsdetails für dieses Sample aus.',
  common_optional: 'optional',
  action_deadline: 'Frist',
  action_description: 'Aktionsbeschreibung',
  action_description_autofill_tooltip: 'Aktionsbeschreibung',
  action_description_autofill_tooltip_description:
    'Automatisch generiert (Runden-ID / Brauerei / Sample-Name / Produktionsdatum / Erstellungsbenutzer) + zusätzliche Beschreibung',
  action_owner: 'Verantwortlicher',
  action_meeting: 'Interaktionsprotokoll-Meeting',
  action_meeting_list: 'IAL-Meeting',
  action_producing_site: 'Produktionsstandort',
  action_production_date: 'Produktionsdatum',
  action_closed_time: 'Abschlusszeit',
  action_meeting_placeholder: 'Bitte Meeting auswählen',
  action_status: 'Status',
  action_status_draft: 'Entwurf',
  action_status_not_started: 'Nicht begonnen',
  action_status_in_progress: 'In Bearbeitung',
  action_status_delayed: 'Verzögert',
  action_status_close: 'Schließen',

  action_menu_close: 'Schließen',
  action_cancel: 'Abbrechen',
  action_add_comment: 'Kommentar hinzufügen',
  action_status_canceled: 'Abgebrochen',
  status_record: 'Statusverlauf',
  no_status_record: 'Keine Statusaufzeichnungen',
  action_type: 'Aktionstyp',
  action_create_user: 'Erstellt von',
  action_create_time: 'Erstellungszeit',
  action_creator: 'Ersteller',
  action_root_cause: 'Grundursache',
  action_description_placeholder: 'Bitte Aktionsbeschreibung eingeben...',
  action_root_cause_placeholder: 'Bitte Grundursache eingeben...',
  action_comment_added: 'Kommentar erfolgreich hinzugefügt',
  action_comment_add_failed: 'Kommentar konnte nicht hinzugefügt werden',
  action_comment_placeholder: 'Geben Sie Ihren Kommentar ein...',
  action_status_changed_with_comment: 'Status mit Kommentar geändert',
  required_comment_banner:
    'Da Sie nicht der Eigentümer dieser Aktion sind, müssen Sie im Namen des Eigentümers einen Kommentar abgeben.',
  cancel_and_comment: 'Abbrechen & Kommentieren',
  close_and_comment: 'Schließen & Kommentieren',
  action_edit_action: 'Aktion bearbeiten',
  action_owner_placeholder: 'Bitte einen Verantwortlichen auswählen',
  action_created_successfully: 'Aktion wurde erfolgreich erstellt!',
  action_created_successfully_desc:
    'Sehen Sie sich die erstellte Aktion in der Aktionsliste an.',
  action_updated_successfully: 'Aktion wurde erfolgreich aktualisiert!',
  action_updated_successfully_desc:
    'Sehen Sie sich die aktualisierte Aktion in der Aktionsliste an.',
  action_create_failed: 'Beim Erstellen der Aktion ist ein Problem aufgetreten',
  action_update_failed:
    'Beim Aktualisieren der Aktion ist ein Problem aufgetreten',
  action_save_failed_desc: 'Bitte versuchen Sie es in Kürze erneut.',
  action_deleted_successfully: 'Aktion wurde erfolgreich gelöscht!',
  action_deleted_successfully_desc: 'Sehen Sie in der Aktionsliste nach.',
  action_delete_failed: 'Beim Löschen der Aktion ist ein Problem aufgetreten',
  delete_action_confirm_title: 'Aktion löschen?',
  delete_action_confirm_description:
    'Diese Aktion wird dauerhaft entfernt. Sind Sie sicher, dass Sie fortfahren möchten?',
  action_added_notification: '[{{userName}}] hat eine neue Aktion hinzugefügt',
  action_updated_notification: '[{{userName}}] hat seine Aktion aktualisiert',
  action_deleted_notification:
    '[{{userName}}] hat seine eigene Aktion gelöscht',
  view_action_list: 'Aktionsliste anzeigen',
  pdf_viewer: 'PDF-Betrachter',
  common_all: 'Alle',
  common_continue: 'Weitermachen',
  common_minimum_score: 'Min',
  common_maximum_score: 'Max',
  common_average_score: 'Durchschnitt',
  file_upload_fail: 'Fehler beim Hochladen der Datei',
  file_upload_success_with_error:
    'Der Upload war bis auf folgende Punkte erfolgreich:',
  missing_fields: 'fehlende Felder',
  column_error: 'Spaltenfehler',
  common_line: 'Leitung',
  file_no_samples: 'Keine Beispiele in der Datei gefunden!',
  file_success_upload: 'Datei erfolgreich hochladen!',
  file_duplicated_kpi_project: 'Duplizierter KPI oder Projekt',
  round_schedule_maximum_length:
    'Die maximale Länge des runden Namens beträgt 40 Zeichen.',
  sample_malt_varieties: 'Malz-Sorte',
  error_sample_already_in_round: 'Die Probe ist schon in der Runde',
  malt_varieties_has_no_english_name:
    'Sie müssen mindestens einen Malzsortennamen haben.',
  malt_varieties_duplicate:
    'Achtung: Es gibt eine Vielzahl von Malzen mit diesem Namen',
  malt_varieties_remove: 'Vielfalt entfernen',
  malt_varieties_new: 'Neue Sorte',
  malt_varieties_edit: 'Sorte bearbeiten',
  malt_varieties_enter_name: 'Namen eingeben',
  malt_varieties_page_description:
    'Verwalten Sie alle Malzsorten und deren Konfigurationen an einem Ort.',
  malt_varieties_save_success: 'Malzsorte erfolgreich erstellt!',
  malt_varieties_save_success_desc:
    'Überprüfen Sie es unten in den Malzsorten.',
  malt_varieties_update_success: 'Malzsorte erfolgreich aktualisiert!',
  malt_varieties_update_success_desc:
    'Überprüfen Sie es unten in den Malzsorten.',
  malt_varieties_delete_title: 'Malzsorte entfernen?',
  malt_varieties_delete_description:
    'Die Malzsorte {{name}} wird dauerhaft entfernt. Möchten Sie wirklich fortfahren?',
  malt_varieties_delete_success: 'Malzsorte erfolgreich gelöscht!',
  malt_varieties_delete_success_desc:
    'Überprüfen Sie es unten in den Malzsorten.',
  malt_varieties_delete_failed: 'Malzsorte konnte nicht gelöscht werden.',
  malt_varieties_delete_failed_desc: 'Bitte versuchen Sie es später erneut.',
  cancel_new_malt_variety_title: 'Neue Malzsorte abbrechen?',
  cancel_edit_malt_variety_title: 'Malzsortenbearbeitung abbrechen?',
  cancel_new_malt_variety_confirm: 'Neue Malzsorte abbrechen',
  cancel_edit_malt_variety_confirm: 'Malzsortenbearbeitung abbrechen',
  reports_no_dates: 'Startdatum und Enddatum sind obligatorisch!',
  reports_date_range_message:
    'Der Datumsbereich darf nicht größer als 1 Jahr sein',
  common_error: 'Hoppla! Etwas ist schief gelaufen. Bitte versuche es erneut',
  common_horizontal: 'Horizontal',
  common_unit: 'Einheit',
  common_supplier: 'Anbieter',
  common_flavor: 'Geschmack',
  concentration_of_the_base_beer: 'Konzentration des Grundbieres',
  threshold_aml_method: 'AML-Methode (aufsteigende Limitmethode)',
  threshold_component_concentration: 'Komponentenkonzentration',
  threshold_sample_different_help: 'Welche Probe ist anders?',
  threshold_each_set_random_order: 'In jedem Satz zufällige Reihenfolge.',
  threshold_select_base_beer: 'Basisbier auswählen',
  common_unity: 'Einheit',
  common_finish_session: 'Sitzung beenden',
  common_filters: 'Filter',
  review_submit_threshold: 'Möchten Sie wirklich speichern?',
  threshold_coder_wrong:
    'Dein Code ist falsch. Bitte teilen Sie den korrekten Code mit!',
  threshold_didnt_enter_the_code: 'Bitte geben Sie Ihre Sitzplatznummer ein',
  code: 'Code',
  threshold_samples_required: 'Grundbier und Aroma sind erforderlich',
  threshold_information_helper_sample:
    'Klicken Sie zum Speichern der Schwellenwertbeispielinformationen auf die Schaltfläche Speichern, um Ihre Änderungen beizubehalten',
  code_digits: 'Geben Sie den Ihnen zugewiesenen 3-stelligen Code ein',
  common_batch_code: 'Batch-Code',
  threshold_sample_spiked_with:
    'Wählen Sie bei jedem Satz die Probe aus, mit der versetzt wurde',
  threshold_code_already_tasted:
    'Dieser Code wurde bereits von einem anderen Benutzer probiert. Geben sie einen anderen Code ein.',
  common_kpi_brands: 'KPI-Marken',
  common_year: 'Jahr',
  common_new_kpi_brand: 'Neue KPI-Marke',
  common_action: 'Aktion',
  kpi_brand_details_title: 'KPI-Marke Details',
  kpi_brand_details_description:
    'Vollständige Informationen und Status des Genehmigungsprozesses anzeigen.',
  approval_action: 'Genehmigungsaktion',
  select_approval_action: 'Genehmigungsaktion auswählen',
  reject_reason_title: 'Ablehnungsgrund',
  reject_reason_description: 'Bitte geben Sie einen Ablehnungsgrund an.',
  reject_reason_label: 'Ablehnungsgrund',
  reject_reason_placeholder: 'Ablehnungsgrund eingeben...',
  reject_reason_placeholder_site:
    "Bitte geben Sie den Ablehnungsgrund für diese Stätte '{{site}}' ein...",
  common_confirm: 'Bestätigen',
  common_success: 'Erfolg',
  common_save_failed:
    'Speichern fehlgeschlagen. Bitte versuchen Sie es erneut.',
  approval_status_saved_success:
    'Genehmigungsstatus wurde erfolgreich gespeichert!',
  common_comment_by_category: 'Kommentare nach Kategorie',
  common_alphabetic_comment: 'Alphabetische Kommentare',
  common_name_pts_code: 'PTS code',
  common_name_pts_code_placeholder: 'Code',
  common_name_process_item: 'Artikel bearbeiten',
  common_name_process_item_placeholder: 'Artikel',

  kpi_only_numbers_warning: 'Akzeptieren Sie nur Zahlen für Zielwerte',
  kpi_max_number_range_warning: 'Ihre Zielmarke muss zwischen 1 und 9 liegen',
  kpi_already_selected_brand_warning:
    'Sie haben diese Marke ausgewählt, bitte wählen Sie eine andere Marke',
  kpi_no_kpi_informed_warning: 'Sie haben keinen Mehrwert',
  kpi_select_year_warning: 'Wählen Sie ein Jahr aus',
  kpi_select_site_warning: 'Wählen Sie eine Website aus',
  kpi_existing_configuration_warning:
    'Sie haben KPI-Werte vom selben Standort und Jahr',
  kpi_target_empty_warning: 'Ein Ziel einer Ihrer Marken ist leer',
  kpi_saved_successfully: 'Ihre Werte wurden erfolgreich gespeichert!',
  kpi_submitted_successfully: 'Ihre Werte wurden erfolgreich übermittelt!',
  kpi_max_decimals_warning:
    'Ihr Zielwert muss bis zu 3 Dezimalstellen betragen',
  kpi_count_as_kpi_sample: 'Zählen Sie als KPI',
  report_list_report_kpi: 'KPI-Bericht',
  report_list_report_taste: 'Geschmacksbericht',
  select_brand_to_filter: 'Wählen Sie eine globale Marke!',
  select_year_to_filter: 'Wählen Sie ein Jahr!',
  samples_uncheck_kpi_sample_tooltip:
    'Deaktivieren Sie dieses Kontrollkästchen, wenn diese Stichprobe nicht im KPI gezählt werden soll',
  submission_type: 'Einreichungstyp',
  reports_mandatory_zone_filter: 'Wählen Sie mindestens eine Zone aus',
  custom_scale_title: 'Maßgeschneiderte Waage',
  custom_scale_grid_header_score: 'Punktzahl',
  custom_scale_grid_header_ageind_scale: 'Forced-Aging-Skala',
  the_value_cannot_be_null: 'Der Wert darf nicht null sein!',
  unique_id: 'Eindeutige ID',
  report_filter_rounds_description:
    'Sie müssen die Pflichtfelder auswählen, um Rundenoptionen zu laden.',
  reports_mandatory_test_type: 'Wählen Sie den Testtyp aus.',
  round_reports_month_warning:
    'Der Zeitraum zwischen Startdatum und Enddatum darf maximal 6 Monate betragen.',
  zone_can_not_empty: 'Region darf nicht leer sein',
  error_loading_data:
    'Fehler beim Laden der Daten. Bitte überprüfen Sie Ihre Verbindung und laden Sie neu.',
  beer_batch: 'Bier Charge',
  list_of_beers: 'Bier Liste',
  random: 'zufällig',
  preview: 'Vorschau',
  select_the_flavor: 'Wählen Sie den Geschmack',
  flavor_threshold: 'Geschmacksschwelle',
  input_digital_number: 'Geben Sie die digitale Nummer ein',
  concentration: 'Konzentration',
  flavor_order: 'Geschmacksfolge',
  last: 'Letzte',
  tasting: 'Verkostung',
  tasting_page_description:
    'Führen Sie eine Probeverkostungsbewertung durch und diskutieren Sie das Ergebnis.',
  confirmation: 'Bestätigung',
  do_you_confirm_the_evaluation_of_this_sample:
    'Bestätigen Sie die Auswertung dieser Probe?',
  confirm: 'bestätigen',
  evaluate: 'Bewertet',
  correct_answer: 'Korrekte Antwort',
  threshold: 'Schwelle',
  let_a_comment_about_the_tasting:
    'Hinterlassen Sie einen Kommentar zur Verkostung',
  send: 'Senden',
  right_now: 'Sofort',
  minute_ago: 'Vor einer Minute',
  hour_ago: 'Vor einer Stunde',
  day_before: 'der Tag zuvor',
  year_ago: 'Vor einem Jahr',
  add_a_flavor: 'Füge einen Geschmack hinzu',
  soft_drinks: 'Alkoholfreie Getränke',
  soft_drinks_brand: 'alkoholfreie Getränke',
  soft_drinks_brand_target: 'Markenziel für Erfrischungsgetränke',
  column_options: 'Spaltenoptionen',
  configure_table_title: 'Spalten anpassen',
  configure_table: 'Tabelle konfigurieren',
  configure_table_description:
    'Wählen Sie sichtbare Spalten aus und legen Sie ihre Reihenfolge fest.',
  configure_table_helper:
    'Mindestens 2 Spalten müssen sichtbar sein, maximal 4 Spalten dürfen fixiert werden.',
  configure_table_fixed_left: 'Links fixiert',
  configure_table_scroll_area: 'Scrollbereich',
  configure_table_fixed_right: 'Rechts fixiert',
  configure_table_empty_left: 'Spalte hierher ziehen, um sie links zu fixieren',
  configure_table_empty_right:
    'Spalte hierher ziehen, um sie rechts zu fixieren',
  configure_table_save: 'Änderungen speichern',
  configure_table_reset: 'Auf Standard zurücksetzen',
  configure_table_discard: 'Änderungen verwerfen',
  configure_table_show: 'Anzeigen',
  configure_table_hide: 'Ausblenden',
  configure_table_min_visible: 'Mindestens 2 Spalten müssen sichtbar bleiben',
  configure_table_max_fixed: 'Sie können bis zu 4 Spalten fixieren',
  configure_table_drag: 'Zum Sortieren ziehen',
  configure_table_dragging: 'Wird gezogen',
  select_which_of_the_columns_do_you_want_to_be_displayed:
    'Wählen Sie aus, welche der Spalten angezeigt werden soll.',
  countdown: 'Countdown',
  less_than_five_minutes:
    'Diese Verkostung endet in 5 Minuten, wenn Sie fortfahren müssen, wenden Sie sich bitte an den Administrator, um das Enddatum zu verschieben.',
  the_countdown_to_the_evaluation_has_ended:
    'Es konnten keine kommentare abgegeben werden, weil der countdown beendet war.',
  counting_how_much_time_does_you_have_to_finish_tasting_the_samples:
    'Rechne, wie lange es dauert, bis diese proben probiert werden',
  only_six_flavors_can_be_added_at_most:
    'Es können nur bis zu sechs Geschmacksrichtungen hinzugefügt werden!',
  concentration_of_the_flavor: 'Konzentration der Geschmacksstoffe',
  input_value: 'Eingabewert',
  Concentration_of_the_flavor_is_required:
    'Konzentration des Geschmacks ist erforderlich',
  previous_round: 'Vorherige Runde',
  next_round: 'Nächste Runde',
  the_end_time_is_greater_than_the_current_time:
    'Die Endzeit muss größer als die aktuelle Zeit sein, wenn Sie den gleichen Tag wie den aktuellen Tag auswählen, wählen Sie zuerst die Stunde und Minute aus!',
  check_the_answer_at_the_end_of_the_countdown:
    'Der countdown ist noch nicht beendet. Die antwort erhalten sie nach dem countdown',
  incremental_step: 'Inkrementeller Schritt',
  set3_concentration: 'Set3 Konzentration',
  concentration_increments_between_levels:
    'Konzentrationsanstiege zwischen Ebenen',
  incremental_set3_concentration_required:
    'Inkrementaler Schritt und Set3 Konzentration sind erforderlich',
  sprint: 'Sprint',
  sprint_number_greater_than_zero: 'Die Sprintnummer muss größer als 0 sein.',
  sprint_notes_at_least_one_note:
    'Sprintnotizen müssen mindestens eine Notiz enthalten.',
  sprint_patch_notes_success_update:
    'Sprint-Patchnotizen erfolgreich aktualisiert.',
  sprint_patch_notes_error_update:
    'Die Notizen konnten nicht gespeichert werden.',
  sprint_number: 'Sprintnummer',
  sprint_patch_notes: 'Sprint-Patchnotizen',
  note: 'Notiz',
  select_all: 'Alle auswählen',
  please_add_samples_first: 'Bitte fügen Sie zuerst ein Muster hinzu',
  reverse: 'Rollback',
  new_test: 'Tests hinzugefügt',
  triangle_test_name: 'Name des Triangulationstests',
  triangle_test: 'Triangulationstest',
  you_can_not_set_three_identical_samples:
    'Sie können nicht dieselben drei Optionen festlegen',
  its_mandatory_to_input_test_name: 'Bitte geben Sie den Testnamen ein',
  its_mandatory_to_input_sample_information:
    'Bitte füllen Sie die Beispielinformationen aus',
  attention: 'Achtung',
  test_number: 'Seriennummer des Triangulationstests',
  you_selected_the: 'Sie haben gewählt',
  next_sample: 'Nächstes Beispiel',
  remove_triangle_test: 'Diesen Test löschen',
  you_can_only_select_up_to_five:
    'Maximal fünf Auswahlmöglichkeiten sind zulässig',
  test: 'Test',
  confirm_remove: 'Löschen des Tests bestätigen?',
  reports_mandatory_zone_country_site_filter:
    'Regionen, Länder, Fabriken sind erforderlich',
  reports_mandatory_brand_filter: 'Wählen Sie mindestens eine Marke aus',
  reports_by_producing_site: 'Vollständiger Analysebericht',
  download_label: 'Schaltfläche "Herunterladen"',
  standard: 'Richtwert',
  input_test: 'Ergebniseingabe',
  detecting: 'Entdeckend...',
  connected: 'Verbunden',
  current_taster: 'Aktuelle Gutachter',
  alcohol_concentration: 'Alkoholkonzentration',
  alcohol_result_submit_failed_title:
    'Beim Übermitteln des Ergebnisses ist ein Problem aufgetreten',
  alcohol_result_submit_failed_desc:
    'Bitte versuchen Sie es gleich noch einmal.',
  your_alcohol_test_result_exceeds_standard_please_test_again_later:
    'Ihre Blutalkoholkonzentration ist zu hoch. Bitte später erneut testen!',
  alcohol_test_qualified: 'Bestehen Sie den Alkoholtest',
  alcohol_concentration_configuration: 'Konfiguration der Alkoholkonzentration',
  breathalyzer_configuration_description:
    'Konfigurieren Sie die Alkoholkonzentration für jeden Standort und den Fahrstatus der Benutzer.',
  breathalyzer_configuration_save_success_title: 'Breathalyzer-Konfiguration erfolgreich aktualisiert!',
  breathalyzer_configuration_save_success_description: 'Die aktualisierten Konfigurationen finden Sie in den Einstellungen unten.',
  breathalyzer_configuration_save_failed_title: 'Beim Aktualisieren der Breathalyzer-Konfiguration ist ein Problem aufgetreten',
  breathalyzer_configuration_save_failed_description: 'Bitte versuchen Sie es gleich noch einmal.',
  cancel_configuration_title: 'Konfiguration abbrechen?',
  cancel_configuration_description: 'Sie haben Änderungen an der Konfiguration vorgenommen. Beim Abbrechen werden nicht gespeicherte Änderungen verworfen. Möchten Sie fortfahren?',
  cancel_configuration_confirm: 'Konfiguration abbrechen',
  driving_configuration: 'Fahrkonfiguration',
  configuration: 'Konfiguration',
  input_result: 'Ergebniseingabe',
  maximum_alcohol_concentration: 'Maximale Alkoholkonzentration',
  breathalyzer: 'Alkoholdetektor',
  breathalyzer_page_description:
    'Verwalten Sie alle Atemalkoholtestergebnisse und deren Konfigurationsstandards an einem Ort.',
  please_input_a_positive_number_up_to_n_decimal_places:
    'Bitte geben Sie eine positive Zahl bis zu {{field}} Dezimalstellen ein',
  you_must_input: 'Sie müssen eingeben',
  driving: 'Autofahren',
  test_time: 'Testzeit',
  input_type: 'Typ eingeben',
  list_breathalyzer: 'Atemanalysator',
  Manual: 'Handbuch',
  auto: 'Automatisch',
  Breathalyzer: 'Atemanalysator',
  you_do_not_have_privilege_to_export_this_report:
    'Sie haben keine Berechtigung, diesen Bericht zu exportieren',
  competitor_beer: 'Wettbewerber Bier',
  split_round: 'Runde teilen',
  reset: 'Zurücksetzen',
  how_many_rounds_splitting_do_you_want_to_make:
    'Wie viele Runden der Spaltung wollen Sie machen',
  you_cannot_split_a_round_that_has_already_been_split_or_in_progress:
    'Eine bereits geteilte oder laufende Runde kann nicht geteilt werden',
  hide_sample_details: 'Beispieldetails ausblenden',
  hide_sample_details_auto_hide:
    'YES - Sie können die Proben aufteilen und automatisch alle versteckten Informationen einblenden, nachdem alle aufgeteilten Runden probiert wurden.',
  hide_sample_details_manual_hide:
    'Manual - Sie können die Proben nicht teilen und müssen einen temporären Administrator beauftragen, die Diskussionsseite manuell ein- oder auszublenden.',
  data_will_be_hidden_from_the_taster_brewery_production_date_brand_malt_variety_and_sample_id:
    'Daten werden vor dem Verkoster verborgen: Brauerei, Produktionsdatum, Marke, Malzsorte und Probe ID',
  this_round_is_selected_manual_unhide_split_function_is_not_available_you_can_choose_auto_hide_or_no_hide_to_split:
    'Diese Runde ist auf Manuell eingestellt, die Teilungsfunktion ist nicht verfügbar, Sie können Auto Hide oder No Hide zum Teilen wählen.',
  data_will_be_hidden_for_ok_nok:
    'Alle relevanten Daten werden vor den Verkostern verborgen.',
  you_can_not_add_duplicate_attributes:
    'Wiederholende eigenschaften können nicht gesetzt werden.',
  menu: 'MENÜ',
  link_breathalyzer: 'Verbunden',
  not_link_breathalyzer: 'Nicht verbunden',
  breathalyzer_to_link: 'Atemanalysator anschließen',
  breathalyzer_connection_failed_title:
    'Verbindung zum Atemalkoholtester fehlgeschlagen',
  breathalyzer_connection_failed_desc:
    'Bitte aktualisieren Sie die Seite und versuchen Sie es erneut.',
  breathalyzer_can_not_to_link_for_this_browser:
    'Die Funktion des Atemanalyzers wurde entwickelt, um auf Google Chrome mit PC-Geräten zu arbeiten.',
  reopen: 'Wiederöffnen',
  round_reopen_message:
    'Sind Sie sicher, dass Sie die Runde wieder eröffnen wollen',
  common_production_line: 'Produktionslinie',
  common_packaged_beer_data_code: 'Datencode für verpacktes Bier',
  common_masking_process_for_bottles: 'Maskierungsverfahren für Flaschen',
  common_str_number_days_over_aged: 'Anzahl der Tage bei Überalterung',
  common_over_aged_beer: 'Überaltertes Bier',
  sample_successfully_swapped: 'Der probenaustausch ist gut gelungen.',
  scoring: 'Bewertung',
  configure_available_flavors: 'Verfügbare Geschmacksrichtungen einrichten',
  process_check: 'Prozesskontrolle',
  new_process_check: 'Neue Prozessprüfung',
  edit_process_check: 'Prozessprüfung bearbeiten',
  remove_process_check: 'Prozessprüfung entfernen',
  common_package: 'Paket',
  common_department: 'Abteilung',
  common_shift: 'Verschiebung',
  common_tank: 'Tank',
  common_oknok: 'OKNOK',
  common_remark: 'Bemerkung',
  show_all_process_check: 'Alle Prozessprüfung anzeigen',
  show_all_process_check_help_circle:
    'Markieren sie dieses feld, um die daten anzuzeigen, die in einem zeitraum Von einem jahr erstellt wurden und die noch im letzten jahr erstellt werden müssen',
  the_sample_date_cannot_be_earlier_than_the_current_time:
    'Das Stichprobendatum kann nicht früher als die aktuelle Zeit sein!',
  common_job_position: 'Berufsposition',
  decimal_sep: 'Dezimaltrennzeichen',
  is_swapped_to: 'wird getauscht auf',
  review_warning_comment_title:
    'Ich sehe, sie haben ein undefiniertes beispiel!',
  continuous_typing: 'Eingabefolge eingeben',
  continuous_typing_tips:
    "Zählen Sie die Eingabe von 'Attribut' nach Auswahl/Eingabe von 'Intensität'.",
  BSSI_Reports: 'BSSI Berichte',
  data_analysis_sip: 'Datenanalyse - SIP',
  select_the_color: 'Wählen Sie die Farbe.',
  color: 'Farben',
  download_document: 'Datei herunterladen',
  Month_of_Discontinued_Production:
    'Der Monat, in dem die Produktion eingestellt wird.',
  Suspension_List: 'Suspensionsliste',
  New_Suspension: 'Neue Suspension',
  new_suspension_page: 'Neue Produktionssuspension',
  edit_suspension_page: 'Suspension bearbeiten',
  Brand_name: 'Markenname',
  List_Brewery_Production_Suspension:
    'Liste der Brauereien zur Produktionssuspension',
  Upload_successfully: 'Datei erfolgreich hochgeladen',
  training_materials: 'Trainingsmaterialien',
  Remove_Suspension: 'Suspension entfernen',
  Add_Absence_Reason: 'Fehlgrund hinzufügen',
  Reason: 'Grund',
  Select_reason: 'Grund auswählen',
  You_have_duplicate_absence_dates: 'Sie haben doppelte Fehldaten',
  Remove_Absence: 'Abwesenheit entfernen',
  Absence_Title:
    'Bitte wählen Sie den Zeitpunkt und Grund Ihrer Abwesenheit bei der Verkostung. Einträge können unter Eingereichter Grund angezeigt oder gelöscht werden.',
  Shipping_Site: 'Versandstandort',
  shipping_received: 'Versand empfangen',
  receive_sample_alert: 'Sind Sie sicher, dass Sie die Proben erhalten haben?',
  receive_uncheck_alert: 'Sind Sie sicher, dass Sie dies zurücknehmen möchten?',
  all_received: 'Alle empfangen',
  not_all_received: 'Nicht alle empfangen',
  not_for_shipping: 'Nicht zum Versand',
  receive_hint: 'Wählen Sie alle Standorte, die zu den Proben gehören',
  absence_reason: 'Fehlgrund',
  Page1: 'Seite {{field}}',
  Search: 'Suchen',
  page_total: 'Gesamtzahl',
  start_date: 'Startdatum',
  end_date: 'Enddatum',
  ok_for_all: 'Das ist für alle das beste',
  its_mandatory_to_select_sample_A_and_sample_B:
    'Wir müssen A und B probieren.',
  its_mandatory_to_select_sample_A: 'Muster A muss ausgewählt werden.',
  its_mandatory_to_select_sample_B: 'Muster B muss ausgewählt werden.',
  triangle_comment: 'Kommentare',
  select_sample: 'Nehmen sie eine probe',
  sample_date_filter_last_7_days_in_default_export_to_Excel_based_on_this_filtered_duration:
    'Beispieldateifilter, standardmäßig die letzten sieben Tage, exportiert nach Excel basierend auf dieser gefilterten Dauer.',
  select_all_flavor: 'Auswahl für alle.',
  deselect_all: 'Deaktivieren sie alle optionen.',
  email_distribution: 'Monatsbericht-Empfänger',
  new_email_distribution: 'Neue Monatsbericht-Empfänger',
  edit_email_distribution: 'Monatsbericht-Empfänger bearbeiten',
  distribution_type: 'Verteilungstyp',
  the_score_entered_is_invalid:
    'Die eingegebene Punktzahl ist ungültig. Bitte beachten Sie die Notenskala und geben Sie Ihre Punktzahl erneut ein.',
  service_now:
    'Klicken sie hier, um einen terminkalender zu erstellen, um probleme zu melden und hilfe zu erhalten',
  service_now_tips:
    'Hey, wenn Sie ein Problem sehen oder um Unterstützung bitten möchten, klicken Sie hier und melden Sie es direkt in serviceNow. Unser Support-Team wird sich so schnell wie möglich mit Ihnen in Verbindung setzen.',
  done: 'Fertig',
  changes_you_made_may_not_be_saved:
    'Änderungen, die Sie vorgenommen haben, werden möglicherweise nicht gespeichert. Möchten Sie fortfahren und Änderungen verlieren?s',
  cannel_auto_save_tips:
    'Jetzt ist die Leistung der Verkostungseite verbessert, denken Sie bitte daran, auf Probe beenden zu klicken, um Ihr Verkostungsergebnis zu speichern und einzureichen.',
  list_email_page_tips:
    'Dies ist die beschreibung dafür, wie die richtige kpi-probe gesetzt werden kann, um sicherzustellen, dass die regionale monatliche berichterstattung eine genaue darstellung des mk-ausfalls ihrer region enthält',
  list_email_page_helps:
    'Die Anleitung, wie Sie KPI-Stichprobe einrichten, um genaue Daten in Ihrem Zone Monatsbericht wiederzugeben.',
  kpi_instruction: 'KPI-Anweisung',
  group_no_recipients_message: 'Es wird mindestens ein Empfänger benötigt.',
  the_current_distribution_type_already_exists:
    'Der aktuelle Distributionstyp existiert bereits, bitte wählen Sie den Typ erneut aus oder geben Sie die Liste zurück.',
  distribution_type_message_empty:
    'Verteilungsart nicht erlaubt leer oder leer',
  add_samples: 'Probe(n) zur Runde hinzufügen',
  copy_this_sample: 'Duplizieren der Probe',
  remove_this_sample: 'Probe entfernen',
  drag_samples_here: 'Proben hierher ziehen',
  drop_here: 'Hier ablegen',
  multiple_selection_tips: `Sie können mehrere Proben desselben Probentyps auf einmal auswählen. Klicken Sie auf '+' und '-', um es auszuprobieren.`,
  all_add_once_tips: `Klicken Sie auf die Schaltfläche "Alle auswählen", um automatisch 1 Probe zu jeder ausgewählten Probenart hinzuzufügen.`,
  user_non_abi_user: 'Neuer temporärer Benutzer',
  language_of_email_invitation: 'Sprache der E-Mail-Einladung',
  add_non_abi_users_to_round:
    'Der temporäre Nutzer erhält eine E-Mail-Einladung mit einem Link zur Teilnahme an der jeweiligen Verkostung.',
  change_non_abi_users_to_round:
    'Zeitweilige Verkoster, die Sie eingeladen haben, erhalten eine E-Mail-Einladung mit einem Link zur Teilnahme an dieser Verkostung.',
  guest: 'Gast',
  email_to_all: 'E-Mail an alle',
  send_email: 'Einladung per E-Mail senden',
  temporary_non_abi_taster: 'Temporärer Verkoster',
  user_type: 'Benutzertyp',
  email_invitation_delivery_request_sent: 'Einladungs-E-Mail-Anfrage gesendet.',
  incorrect_e_mail_formatting: 'Falsche E-Mail-Formatierung',
  all_tasters: 'Alle Verkoster',
  tasters: 'Verkoster',
  key_tasters: 'Key Tasters',
  non_key_tasters: 'Nicht-Schlüsseltaster',
  taster_already_started_cannot_change:
    'Verkoster hat bereits begonnen, kann nicht geändert werden',
  temporary: 'Temporärer Benutzer',
  maximum_number_of_samples_is: 'Die maximale Anzahl von Proben ist',
  sample_added: 'Probe hinzugefügt',
  click_to_view_scale_of_flavour_intensities:
    'Klicken Sie auf den Link, um die detaillierten Intensitätsskalen zu sehen',
  list_next_week_plan: 'Plan für die nächste Woche',
  common_time_zone: 'Zeitzone',
  common_last_response_time: 'Letzte Antwortzeit',
  new_week_plan: 'Neuer Wochenplan',
  invited_week: 'Eingeladene Woche',
  email_language: 'E-Mail-Sprache',
  save_and_send_email: 'E-Mail speichern und senden',
  common_start_time: 'Startzeit',
  common_end_time: 'Endzeit',
  session_name_email_subject: 'Name der Sitzung / E-Mail-Betreff',
  location: 'Standort',
  edit_week_plan: 'Wochenplan bearbeiten',
  email_response: 'E-Mail-Antwort',
  round_remove_plan: 'Sind Sie sicher, dass Sie den Plan löschen möchten',
  view_week_plan: 'Wochenplan ansehen',
  are_you_confirming_to_send_the_confirmation_email:
    'Bestätigen Sie den Versand der Bestätigungs-E-Mail',
  every_10_minutes_system_will_update_the_email_response_from_next_week_plan_invitation:
    'Alle 10 Minuten aktualisiert das System die E-Mail-Antwort auf die Einladung der nächsten Woche.',
  documents_upload_tips: 'Datei-Uploads unterstützen nur {{field}}',
  ignore_submit: 'Ignorieren&Absenden',
  if_count_as_kpi:
    'Wenn dieses Feld leer ist, werden die KPIs als "Count as KPI" kennzeichnet',
  confirmed_count: 'Bestätigte Anzahl',
  accepted: 'Akzeptiert',
  declined: 'Abgelehnt',
  no_response: 'Keine Antwort',
  reminder_time: 'Erinnerung Zeit',
  apply_to_all_sessions: 'Anwenden auf alle Sitzungen',
  are_you_sure_you_want_to_change_the_week_of_invitation:
    'Sind Sie sicher, dass Sie die von Ihnen gewählte Start-/Endzeit der Sitzung entfernen und zu einer anderen Eingeladenen Woche wechseln möchten',
  apply_to_all_sessions_location_tasters: `Anwenden von "Standort" und "Tasters" auf folgende Sitzungen`,
  mcs_tasting: 'KPI-Verkostung',
  qcs_tasting: 'KPI-Verkostung',
  mcs_tasting_tips:
    'Wählen Sie Ja, wenn diese Runde MCS/KPI-Proben enthält. Das System wendet dann den entsprechenden KPI-Code für die Probenmarke an.',
  round_samples_shuffle_confirm:
    'Sind Sie sicher, dass Sie die Sets mischen wollen?',
  all_count_as_kpi: 'Alle zählen als KPI',
  msc_tasting_tour_mask:
    'Das System identifiziert automatisch den entsprechenden KPI-Code auf der Grundlage der gezählten Stichprobe mit dem richtigen KPI-Monat, so dass Sie NICHT verschiedene Marken in einer Runde aufteilen müssen.',
  competition: 'Wettbewerb',
  copy_link: 'Link kopieren',
  open_link: 'Link öffnen',
  common_download_img: 'IMG herunterladen',
  please_select_taster: 'Bitte wählen Sie eine Kostprobe',
  user_principal_name: 'Benutzerprinzipalname',
  user_status: 'Benutzerstatus',
  termination_date: 'Enddatum',
  function_level: 'Funktionsebene',
  last_update_time: 'Letztes Update',
  system_related: 'Systembezogen',
  workday_related: 'Arbeitstagsbezogen',
  employee_id: 'Mitarbeiter-ID',
  zitec_project_name: 'Name des Projekts',
  applicant: 'Antragsteller',
  applicant_date: 'Datum des Antrags',
  test_method: 'Testmethode',
  liquid_category: 'Flüssigkeits-Kategorie',
  conditions: 'Bedingungen',
  time_points: 'Zeitpunkte',
  execution_date: 'Ausführungsdatum',
  execution_by_time_points: 'Berechnetes Ausführungsdatum nach Zeitpunkten',
  invitation_start_time: 'Einladung Startzeit',
  invitation_end_time: 'Einladung Endzeit',
  invitation_reminder: 'Einladung Erinnerung',
  application_form: 'Antragsformular',
  application_form_result: 'Anmeldeformular Ergebnis',
  upload_result: 'Ergebnis hochladen',
  zitec_sessions: 'ZITEC-Sitzungen',
  zitec_id: 'ZITEC ID',
  new_zitec_session: 'Neue ZITEC-Sitzung',
  common_search_applicant: 'Antragsteller suchen',
  history_record: 'Datensatz',
  common_quarterly: 'Quartalsweise',
  common_month: 'Monat',
  kpi_report: 'KPI Bericht',
  kpi_result: 'Anaplan-Datei',
  action_log: 'Aktionsprotokoll',
  validate_data: 'Daten validieren',
  push_anaplan_window_open_date: 'Push Anaplan-Fenster Offenes Datum:',
  unLock_kpi: 'KPI entsperren',
  lock_kpi: 'KPI sperren',
  locked: 'Gesperrt',
  unlocked: 'Entsperrt',
  menu_kpi_lock: 'KPI-Sperre',
  freshness_kpi_lock: 'Frische Sperre',
  in_profile_kpi_lock: 'In Profile Sperre',
  are_you_sure_you_want_to_lock_kpi:
    'Sind Sie sicher, dass Sie KPI für {{field}} sperren wollen',
  are_you_sure_you_want_to_unlock_kpi:
    'Sind Sie sicher, dass Sie die KPI {{field}} entsperren möchten',
  lock_kpi_month_zone:
    'Ihre Aktion ist aufgrund der Sperre der KPI-Stichprobe eingeschränkt, die für einen bestimmten KPI-Monat und -Zone aktiv wurde. Bei Fragen wenden Sie sich bitte an Ihren Zoneneigentümer, um weitere Details zur KPI-Datensperrung zu erhalten.',
  lock_freshness_kpi_month_zone:
    'Ihre Aktion ist aufgrund der Sperre der KPI-Stichprobe eingeschränkt, die für ein bestimmtes KPI-Quartal und eine Zone aktiv wurde. Bei Fragen wenden Sie sich bitte an Ihren Zoneneigentümer, um weitere Details zur KPI-Datensperrung zu erhalten.',
  submit_timeout:
    'Übermittlung fehlgeschlagen, bitte versuchen Sie es später erneut!',
  anaplan_un_upload_tips:
    'Bitte warten Sie auf das nächste geöffnete Anaplan-Fenster!',
  anaplan_un_confirm_tips:
    'Bitte bestätigen Sie die KPI-Daten für den jeweiligen Monat!',
  confirmed: 'Bestätigt',
  confirm_data: 'Daten bestätigen',
  flavor_groups: 'Geschmacksgruppen',
  compound: 'Verbindung',
  sit_code_not_exist:
    'Dieser Sitzplatzcode existiert nicht, bitte beachten Sie das Format des Sitzplatzcodes wie 001, 002.',
  sit_code_chose:
    'Dieser Sitzplatzcode wurde ausgewählt, bitte geben Sie Ihren richtigen Sitzplatzcode ein.',
  kpi_lock: 'KPI-Sperre',
  kpi_confirmation: 'KPI-Bestätigung',
  global_kpi_lock: 'Global KPI Sperre',
  select_month: 'Wählen Sie einen Monat',
  need_to_wait_global_lock: 'Sie müssen warten, bis Global gesperrt ist.',
  monthly_kpi_locked_zones: 'Monatlicher KPI Gesperrte Zonen',
  flavor_confirm_save: `Die nicht ausgewählten Geschmacksrichtungen '{{field}}' befinden sich in den hinzugefügten Proben. Wenn Sie bestätigen, die aktuelle Geschmackskonfiguration zu speichern, werden die entsprechenden Proben gelöscht`,
  temporary_admin: 'Verwaltung auf Zeit',
  unhide_sample_details: 'Probendetails einblenden',
  hide_sample: 'Muster ausblenden',
  download_report_timeout_error_message:
    'Timeout-Zugang, bitte überprüfen Sie die Netzwerkverbindung',
  you_can_only_select_up_to:
    'Sie können nur bis zu {{field}} auswählen, bitte reduzieren Sie die Anzahl der Optionen.',
  push_anaplan: 'Push Anaplan',
  pushed: 'Push Fertigstellung',
  self_evaluation_report:
    'Klicken Sie hier, um den Selbstbewertungsbericht herunterzuladen',
  date_range: 'Datumsbereich',
  kpi_month_range: 'KPI Monat Bereich',
  quick_select: 'Schnellauswahl',
  current_month: 'Aktueller Monat',
  current_year: 'Aktuelles Jahr',
  a_whole_year: 'Ein ganzes Jahr',
  download_self_evaluation_report: 'Download Selbstbewertungsbericht',
  select_tasters: 'Verkoster auswählen',
  create_ticket: 'Ticket erstellen',
  sensory_intelligent_platform: 'Intelligente Sensory-Plattform - PBI',
  external_links: 'Externe Links',
  evaluation_report: 'Bewertungsbericht',
  download_evaluation_report: 'Bewertungsbericht herunterladen',
  taster_type: 'Schnuppertyp',
  taster_evaluation_tip:
    'Jetzt können Sie hier klicken, um Ihren Selbstbewertungsbericht herunterzuladen!',
  admin_evaluation_tip:
    'Jetzt können Sie hier klicken, um den Bewertungsbericht der Tester herunterzuladen',
  kpi_sample: 'KPI-Beispiel',
  add_to_download_list: 'Zur Download-Liste hinzufügen',
  to_download_list: 'Zum Download',
  selected_tasters: 'Ausgewählte Kostproben',
  generation_time: 'Generierungszeit',
  start_month: 'Startmonat',
  end_month: 'Endmonat',
  download_all: 'Alle herunterladen',
  new_physchem_tips:
    'Jetzt können Sie hier klicken, um physchem für die Probe hinzuzufügen',
  view_physchem_tips:
    'Jetzt können Sie hier klicken, um die physikalisch-chemischen Eigenschaften der Proben der aktuellen Runde anzuzeigen.',
  physchem_disabled_tips:
    'Phychem kann nicht angezeigt werden, wenn Proben ausgeblendet sind.',
  package_code: 'Verpackungscode',
  concentration_at_fu: 'Konzentration bei 1 Geschmackseinheit',
  base_beer: 'Grundbier',
  flavor_intensities_scale: 'Skala der Geschmacksintensitäten',
  flavor_unit: 'Geschmackseinheit',
  add_a_sample: 'Probe hinzufügen',
  common_kpi_quarter: 'KPI Quartal',
  sample_duplicated_quarter_kpi_message:
    'Es gibt bereits einen KPI für das von Ihnen ausgewählte Quartal, die Marke und die Website, und Sie können nicht speichern.',
  select_quarter: 'Wählen Sie das Quartal aus',
  please_select_kpi_quarter: 'Bitte wählen Sie das KPI-Quartal aus',
  error_fields: 'Fehlerfelder',
  your_answer: 'Ihre Antwort',
  preference: 'Präferenz',
  please_select_preference_group:
    'Sie müssen Ihre Präferenzen auswählen, bevor Sie den Antrag einreichen!',
  monthly_report: 'Monatsbericht',
  draft: 'Entwurf',
  confirm_send: 'Bestätigen & Senden',
  sent_completion: 'Gesendet Fertiggestellt',
  send_draft: 'Entwurf senden',
  send_draft_monthly_report:
    'Senden Sie den Monatsbericht an Ihre E-Mail-Adresse.',
  please_confirm_the_recipients:
    'Bitte bestätigen Sie die Empfänger des Monatsberichts.',
  total_recipients: 'Gesamtzahl der Empfänger',
  sending: 'Senden',
  sending_monthly_report_tips1: `Ihre Anfrage wird derzeit bearbeitet.`,
  sending_monthly_report_tips2: `Bitte überprüfen Sie das 'Aktionsprotokoll' auf das Ergebnis.`,
  configure_upgrade_center: 'Upgrade-Center konfigurieren',
  sprint_content: 'Sprint-Inhalt',
  release_date: 'Veröffentlichungsdatum',
  add_sprint: 'Sprint hinzufügen',
  sprint_materials: 'Sprint-Materialien',
  upgrade_center: 'Upgrade-Center',
  function: 'Funktion',
  my_evaluation_report: 'Mein Bewertungsbericht',
  upgrade_center_remove_sprint_number:
    'Möchten Sie diese Sprint-Nummer wirklich entfernen',
  sprint_version_tips:
    'Klicken Sie hier, um die Sprint-Materialien anzuzeigen.',
  edit_sprint: 'Sprint bearbeiten',
  new_sprint_tips:
    'Jetzt können Sie hier klicken, um die Sprint-Materialien anzuzeigen.',
  production_date_range: 'Produktionszeitraum',
  quality: 'Qualität',
  preparation: 'Vorbereitung',
  panel: 'Panel',
  session: 'Sitzung',
  product: 'Produkt',
  attribute: 'Attribut',
  common_menu_samples: 'Proben',
  common_menu_rounds: 'Runden',
  common_menu_groups: 'Gruppen',
  common_menu_suspension_list: 'Suspension',
  common_menu_planning_week_sessions: 'Planungswochen-Sessions',
  common_menu_zitec_sessions: 'ZITEC-Sessions',
  common_menu_brands: 'Marken',
  common_menu_kpi_brands: 'KPI-Marken',
  common_menu_packages: 'Pakete',
  common_menu_styles: 'Stile',
  common_menu_malt_variety: 'Malzsorten',
  common_menu_intensities: 'Intensitäten',
  common_menu_categories: 'Kategorien',
  common_menu_attributes: 'Attribute',
  common_menu_user_management: 'Benutzerverwaltung',
  common_menu_role_management: 'Rollenverwaltung',
  common_menu_permission_control: 'Berechtigungssteuerung',
  system: 'System',
  custom_scale_grid_header_aging_scale: 'Reifeskala',
  select_taste_type: 'Probetyp auswählen',
  select_round: 'Runde auswählen',
  a_previous_request_is_still_being_processed:
    'Eine vorherige Anfrage wird noch verarbeitet. Bitte versuchen Sie es später erneut.',
  select_item: '{{field}} auswählen',
  common_new_kpi_brand_button: 'Neue KPI-Marke',
  common_target: 'Ziel',
  common_focus_brands: 'Fokusmarken',
  common_strategic_brands: 'Strategische Marken',
  kpi_brands_new_page_description:
    'Oberfläche zum Erstellen neuer KPI-Marken, mit Funktionen zum Ausfüllen der KPI-Markeninformationen, Senden und Speichern.',
  kpi_brands_edit_page_description:
    'KPI-Marke bearbeiten, mit Funktionen zum Aktualisieren, Einreichen und Speichern von KPI-Marke-Informationen.',
  kpi_brands_edit_page_description_prefix:
    'KPI-Marken anzeigen und konfigurieren für ',
  kpi_brands_page_description:
    'Verwaltungsoberfläche für KPI-Marken, mit Anzeige-, Senden- und Prüffunktionen.',
  table_apply: 'Anwenden',
  table_clear: 'Löschen',
  table_search: 'Suchen',
  table_enter_to_filter: 'Zum Filtern eingeben...',
  table_select_to_filter: 'Zum Filtern auswählen...',
  table_select_all: 'Alle auswählen',
  table_select_all_aria: 'Alle Zeilen auswählen',
  table_select_row_aria: 'Zeile auswählen',
  table_filter_by: 'Filtern nach',
  table_clear_filters: 'Filter löschen',
  table_reset_filters: 'Filter zurücksetzen',
  table_no_results_for_filters: 'Für die angewendeten Filter wurden keine Ergebnisse gefunden.',
  table_items_selected: 'Elemente ausgewählt',
  table_sort: 'Sortieren',
  table_sort_toggle: 'Klicken, um die Sortierung umzuschalten',
  table_no_options: 'Keine Optionen verfügbar',
  table_reset: 'Zurücksetzen',
  table_all: 'Alle',
  table_no_results: 'Keine Ergebnisse für die angewandten Filter gefunden',
  common_approved_at: 'Genehmigt am {{date}}',
  common_rejected_at: 'Abgelehnt am {{date}}',
  kpi_status_created: 'Erstellt',
  kpi_status_waiting_for_approval: 'Wartet auf Genehmigung',
  kpi_status_approved: 'Genehmigt',
  kpi_status_rejected: 'Abgelehnt',
  kpi_action_approve: 'Genehmigen',
  kpi_action_reject: 'Ablehnen',
  common_by_user: 'von {{user}}',
  pagination_aria_label_next_page: 'Zur nächsten Seite gehen',
  pagination_aria_label_previous_page: 'Zur vorherigen Seite gehen',
  pagination_aria_label_first_page: 'Zur ersten Seite gehen',
  pagination_aria_label_last_page: 'Zur letzten Seite gehen',
  pagination_aria_label_input:
    'Geben Sie die gewünschte Seite ein, von 1 bis {totalItems}',
  pagination_aria_label_items_per_page:
    '{pageSize} Elemente pro Seite ausgewählt, klicken Sie zum Ändern',
  pagination_lines_per_page: 'Zeilen pro Seite',
  pagination_total_pages: 'von {totalPages}',
  pagination_total_elements:
    '{firstItem}-{lastItem} von {totalItems} Ergebnissen',
  pagination_no_results: 'Keine Ergebnisse gefunden',
  kpi_brand_successfully_saved: 'KPI-Marke erfolgreich gespeichert!',
  kpi_brand_saved_description:
    'Überprüfen Sie es in der KPI-Marke unten. Dies ist nur eine vorübergehende Speicherung, die Genehmigungseinreichung ist noch nicht abgeschlossen.',
  kpi_brand_failed_to_save: 'KPI-Marke konnte nicht gespeichert werden.',
  kpi_brand_save_failed_description: 'Bitte versuchen Sie es später erneut.',
  kpi_brand_successfully_submitted: 'KPI-Marke erfolgreich erstellt!',
  kpi_brand_submitted_description:
    'Sehen Sie sich die KPI-Marke unten an. Bitte prüfen Sie den Genehmigungsfortschritt auf der Detailseite; diese KPI-Marke ist erst nach Genehmigung verfügbar.',
  kpi_brand_failed_to_submit: 'Erstellung der KPI-Marke fehlgeschlagen.',
  kpi_brand_submit_failed_description: 'Bitte versuchen Sie es später erneut.',
  flavor_id_discussion: 'Diskussion zur Geschmacksidentifikation',
  view_and_discussion_for: 'Ansehen und diskutieren für',
  common_cup: 'Glas',
  tasters_joined: 'Teilgenommene Verkoster',
  tasters_all_correct: 'Verkoster mit allem richtig',
  total_accuracy: 'Gesamtgenauigkeit',
  accuracy: 'Genauigkeit',
  all_correct: 'Alles richtig',
  otherwise: 'Sonstige',
  result: 'Ergebnis',
  Key: 'Key',
  nonkey: 'Nonkey',
  common_guest: 'Gast',
  view_correct_answers: 'Richtige Antworten anzeigen',
  hide_correct_answers: 'Richtige Antworten ausblenden',
  change_to_table: 'Zur Tabellenansicht wechseln',
  change_to_card: 'Zur Kartenansicht wechseln',
  not_answered: 'Nicht beantwortet',
  actions: 'Aktionen',
  actions_page_description:
    'Alle Aktionen anzeigen, die von Benutzern während der Verkostungssitzung erstellt wurden.',
  action_created_by: 'Erstellt von',
  my_actions: 'Meine Aktionen',
  action_list_info: 'Die Aktion wird nach dem Schließen der Runde erstellt.',
  unsaved_changes_warning:
    'Sie haben ungespeicherte Änderungen. Möchten Sie die Seite wirklich verlassen?',
  common_go_back: 'Zurück',
  cancel_create_action_title: 'Aktionserstellung abbrechen?',
  cancel_edit_action_title: 'Bearbeitung der Aktion abbrechen?',
  cancel_create_action_confirm: 'Aktionserstellung abbrechen',
  cancel_edit_action_confirm: 'Aktionsbearbeitung abbrechen',
  unsaved_changes_description:
    'Sie haben Inhalte eingegeben. Beim Abbrechen gehen alle ungespeicherten Eingaben verloren. Möchten Sie fortfahren?',
  unsaved_changes_edit_description:
    'Sie haben Inhalte geändert. Beim Abbrechen gehen alle ungespeicherten Änderungen verloren. Möchten Sie fortfahren?',
  action_update_failed_desc: 'Bitte versuchen Sie es gleich noch einmal.',
  action_change_status_successfully: 'Status geändert!',
  action_change_status_successfully_desc:
    'Der Aktionsstatus wurde auf {{status}} geändert.',
  action_change_status_failed: 'Der Status konnte nicht geändert werden',
  action_change_status_failed_desc:
    'Der Aktionsstatus konnte nicht geändert werden. Bitte versuchen Sie es erneut.',
  download_report_success: 'Berichte erfolgreich heruntergeladen!',
  download_report_success_desc: 'Sie finden sie in Ihrem Download-Ordner.',
  download_self_evaluation_report_success:
    'Selbstbewertungsbericht erfolgreich heruntergeladen!',
  download_report_failed: 'Berichte konnten nicht heruntergeladen werden.',
  download_report_failed_desc: 'Bitte versuchen Sie es später erneut.',
  evaluation_report_add_success: 'Bericht erfolgreich hinzugefügt!',
  evaluation_report_add_success_desc:
    "Sehen Sie ihn im Bewertungsbericht 'Zum Download' an.",
  evaluation_report_add_failed: 'Bericht konnte nicht hinzugefügt werden.',
  evaluation_report_add_failed_desc: 'Bitte versuchen Sie es später erneut.',
  add_taster: 'Verkoster hinzufügen',
  alcohol_concentration_result: 'Ergebnis der Alkoholkonzentration',
  absence_save_success: 'Abwesenheitsgrund erfolgreich hinzugefügt!',
  absence_save_success_desc: 'Sie finden ihn unter Eingereichte Abwesenheiten.',
  submitted_absence: 'Eingereichte Abwesenheiten',
  no_absence_to_show: 'Keine Abwesenheiten vorhanden',
  no_more_data: 'Keine weiteren Daten',
  absence_delete_success: 'Abwesenheitsgrund erfolgreich gelöscht!',
  absence_delete_success_desc: 'Prüfen Sie die aktualisierte Liste unter Eingereichte Abwesenheiten.',
  absence_delete_confirm_title: 'Abwesenheit löschen?',
  absence_delete_confirm_description: 'Der Abwesenheitseintrag [{{start}} - {{finish}}] wird dauerhaft gelöscht. Möchten Sie fortfahren?',
  absence_delete_confirm_delete: 'Löschen',
  absence_save_failed: 'Abwesenheitsgrund konnte nicht hinzugefügt werden',
  absence_save_failed_desc: 'Bitte versuchen Sie es später erneut.',
  absence_duplicate_date_desc:
    'Für das ausgewählte Datum existiert bereits ein Abwesenheitseintrag. Doppelte Einreichungen sind nicht zulässig.',
  absence_delete_failed: 'Abwesenheitsgrund konnte nicht gelöscht werden',
  absence_delete_failed_desc: 'Bitte versuchen Sie es später erneut.',
  role_management_change_role: 'Rolle wechseln',
  role_management_reset_success: 'Berechtigungen erfolgreich zurückgesetzt!',
  role_management_reset_success_desc: 'Die Berechtigungen dieser Rolle wurden auf die Standardkonfiguration zurückgesetzt. Sie können sie unten in der Berechtigungssteuerung überprüfen.',
  role_management_reset_failed: 'Berechtigungen konnten nicht zurückgesetzt werden.',
  role_management_reset_failed_desc: 'Bitte versuchen Sie es später erneut.',
  role_management_switch_role_title: 'Änderungen verwerfen?',
  role_management_switch_role_description: 'Es gibt nicht gespeicherte Berechtigungsänderungen. Beim Wechseln der Rolle werden diese verworfen. Möchten Sie fortfahren?',
  role_management_switch_role_confirm: 'Rolle wechseln',
  role_management_created: 'Benutzerdefinierte Rolle erfolgreich erstellt!',
  role_management_created_desc: 'Sie finden sie unten in der Berechtigungsverwaltung.',
  role_management_permissions_failed: 'Berechtigungen konnten nicht geladen werden.',
  role_management_create_failed: 'Rolle konnte nicht erstellt werden.',
  role_management_create_required: 'Geben Sie einen Rollennamen ein und wählen Sie einen Berechtigungssatz aus.',
  role_management_create_failed_desc: 'Bitte versuchen Sie es später erneut.',
  role_management_create_duplicate: 'Dieser Rollenname ist bereits vorhanden!',
  role_management_create_duplicate_desc: 'Bitte geben Sie einen anderen Rollennamen ein und versuchen Sie es erneut.',
  role_management_save_success: 'Rollenberechtigungen erfolgreich aktualisiert!',
  role_management_save_success_desc: 'Die Änderungen wurden gespeichert. Sie können sie unten in der Berechtigungsverwaltung prüfen.',
  role_management_save_failed: 'Rolländerungen konnten nicht gespeichert werden.',
  role_management_save_failed_desc: 'Bitte versuchen Sie es später erneut.',
  role_management_permission: 'Funktion',
  role_management_view: 'Anzeigen',
  role_management_edit: 'Bearbeiten',
  role_management_approve: 'Genehmigen',
  role_management_search: 'Rollen suchen',
  role_management_current_role_prefix: 'Ihre aktuelle Rolle ist',
  role_management_create: 'Benutzerdefinierte Rolle erstellen',
  role_management_save_changes: 'Änderungen speichern',
  common_apply: 'Anwenden',
  role_management_reset_title: 'Berechtigungen auf Standard zurücksetzen?',
  role_management_reset_tooltip: 'Berechtigungen auf die Konfiguration von [{{parentRole}}] zurücksetzen.',
  role_management_reset_description: 'Die Berechtigungen der Rolle werden auf die Standardkonfiguration zurückgesetzt und alle manuellen Änderungen entfernt. Diese Aktion kann nicht rückgängig gemacht werden.',
  cancel_create_role_title: 'Erstellung der benutzerdefinierten Rolle abbrechen?',
  cancel_create_role_confirm: 'Rollenerstellung abbrechen',
  cancel_create_role_description: 'Sie haben Eingaben im Formular vorgenommen. Beim Abbrechen werden alle nicht gespeicherten Eingaben verworfen. Möchten Sie fortfahren?',
  role_management_delete_title: 'Benutzerdefinierte Rolle löschen?',
  role_management_default_role: 'die Standardrolle',
  role_management_delete_preview_no_users: 'Die benutzerdefinierte Rolle „{{role}}“ wird dauerhaft entfernt. Möchten Sie fortfahren?',
  role_management_create_title: 'Benutzerdefinierte Rolle erstellen',
  role_management_role_name: 'Rollenname',
  role_management_permission_set: 'Benutzerdefinierte Berechtigungen basierend auf',
  role_management_role_name_placeholder: 'Rollennamen eingeben',
  role_management_permission_set_placeholder: 'Basisrolle auswählen',
  role_management_reset_success: 'Berechtigungen erfolgreich zurückgesetzt!',
  role_management_reset_success_desc: 'Die Berechtigungen dieser Rolle wurden auf die Standardkonfiguration zurückgesetzt. Sie können sie unten in der Berechtigungssteuerung überprüfen.',
  role_management_reset_failed: 'Berechtigungen konnten nicht zurückgesetzt werden.',
  role_management_reset_failed_desc: 'Bitte versuchen Sie es später erneut.',
};
